import {useState, useEffect} from 'react'
import {Chargement} from "./Chargement"
import {Aff_question} from "./Aff_question"
import {MathJax, MathJaxContext } from "better-react-mathjax";

export function Mode_classe ({auth, setMode_classe}) {

  const [num, setNum] = useState(0)
  const [correc, setCorrec] = useState(false)
  const questions = auth.questions.filter(e => e)

  const handleClick = (e) => {
    setNum(n => e.target.className == 'suivant' ? n+1 : Math.max(0, n-1))
  }

  useEffect(()=>{
    setNum(0)
  },[]); 

  useEffect(()=>{
    if(typeof window?.MathJax !== "undefined"){
      window.MathJax.typeset()
    }
  },[questions]); // MathsJax 


const elt_co = []
  questions.forEach(e => {
    if(e.length === 5){
      elt_co.push((e[4]+'').split('_')[0])
    }
    if(e.length === 4){
      if((''+e[3][e[3].length-1]).includes('checkbox')) {
        const n = e[3][e[3].length-1].slice(-1)
        let elt_rep = e[3][0]
        for (let i=1; i<n; i++) {
          elt_rep += ' et '+e[3][i]
        }
        elt_co.push(elt_rep)
      } else {elt_co.push(e[3][0])}      
    } 
    
  })

 function ElementCorr ({nb}) {
    return <div className="page correc">
        {nb === 1 ? <div className="message center" dangerouslySetInnerHTML={{ __html:'<b>Réponse '+(num+1)+'</b><br/><br/>'+elt_co[num]}}>
          </div>
          : elt_co.map((e,k)=><div key={k} className="message" dangerouslySetInnerHTML={{ __html:'<b>Réponse '+(k+1)+'</b><br/><br/>'+e}}>
                              </div>
        )}
      </div>
  }

  //console.log(questions)
  return (
    <MathJaxContext>
    <div className="mode_classe_content">
    {num < questions.length ? 
          <>
            <Aff_question handleClick={handleClick} question={questions[num]} mode_classe={true} num_quest={num+1+'. '} />
            {correc && <ElementCorr nb={1} />}
          </>
          : <>
            <div className="page">
              <h1>Fin de la série</h1>
              <div className="cadre" style={{left:'50%', transform: 'translateX(-50%)', marginTop:'20px'}}>{auth.titre}</div>
              <br/>
              <input type="button" className="btn" value="Correction" onClick={()=>setCorrec(!correc)} />
              <br/>
              <input type="button" className="btn" value="Retour" onClick={() => setMode_classe(false)} />
              <div className="precedent" onClick={()=>setNum(num-1)}></div>
            </div>
            {correc && <ElementCorr nb={10} />}
          </>
      }
      
    </div>
    </MathJaxContext>
  );
}